import { render, staticRenderFns } from "./TakeTicket.vue?vue&type=template&id=29965c9f&scoped=true&"
import script from "./TakeTicket.vue?vue&type=script&lang=js&"
export * from "./TakeTicket.vue?vue&type=script&lang=js&"
import style0 from "./TakeTicket.vue?vue&type=style&index=0&id=29965c9f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29965c9f",
  null
  
)

export default component.exports